import React, { useReducer, useContext } from 'react';

import { firestoreInitialize } from 'config/firebase/client';

import EventsContext from './EventsContext';
import EventsReducer from './EventsReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const EventsState = (props) => {
    const initialState = {
        getEvents: {
            events: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getAlliesFromEvents: {
            allies: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        }
    }

    const { authenticatedState } = useContext(AuthenticationContext)

    const [state, dispatch] = useReducer(EventsReducer, initialState);

    const getEvents = (page) => {
        dispatch({ type: 'GET_EVENTS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalEvents(page);
        } else {
            getEventsPerCountry(page, authenticatedState.user.pais);
        }
    };

    const getGlobalEvents = (page) => {
        let db = firestoreInitialize();

        let allies;
        let contents;
        let promotions;
        let allItems;

        const alliesRef = db.collection('Aliados').where('isApproved', '==', false);
        
        alliesRef.get().then(documentSnapshot => {
            allies = documentSnapshot.docs.map(doc => doc.data())
            
            const contentsRef = db.collection('Contenido').where('isApproved', '==', false);
            
            contentsRef.get().then(documentSnapshot => {
                contents = documentSnapshot.docs.map(doc => doc.data())

                const promotionsRef = db.collection('Promociones').where('isApproved', '==', false);

                promotionsRef.get().then(documentSnapshot => {
                    promotions = documentSnapshot.docs.map(doc => doc.data())
                    allItems = allies;
                    let contentsConcat = allItems.concat(contents);
                    let allEvents = contentsConcat.concat(promotions);

                    let nextPage;
                    let data = [];

                    if (page === '1') {
                        data = allEvents.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        data = allEvents.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }

                    dispatch({ type: 'GET_EVENTS', payload: { data: data } });
                });
            });
        });
    };

    const getEventsPerCountry = (page, country) => {
        let db = firestoreInitialize();

        let allies;
        let contents;
        let promotions;
        let allItems;

        const alliesRef = db.collection('Aliados')
            .where('pais', '==', country)
        
        alliesRef.get().then(documentSnapshot => {
            allies = documentSnapshot.docs.map(doc => doc.data())
            allies = allies.filter(ally => typeof ally.isApproved === 'undefined');
            
            const contentsRef = db.collection('Contenido')
                .where('pais', '==', country)
            
            contentsRef.get().then(documentSnapshot => {
                contents = documentSnapshot.docs.map(doc => doc.data())
                contents = contents.filter(content => typeof content.isApproved === 'undefined');

                const promotionsRef = db.collection('Promociones')
                    .where('pais', '==', country)

                promotionsRef.get().then(documentSnapshot => {
                    promotions = documentSnapshot.docs.map(doc => doc.data())
                    promotions = promotions.filter(promotion => typeof promotion.isApproved === 'undefined');

                    allItems = allies;
                    let contentsConcat = allItems.concat(contents);
                    let allEvents = contentsConcat.concat(promotions);

                    let nextPage;
                    let data = [];

                    if (page === '1') {
                        data = allEvents.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
                        data = allEvents.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }

                    dispatch({ type: 'GET_EVENTS', payload: { data: data } });
                });
            });
        });
    }

    const getAlliesFromEvents = (allies) => {
        dispatch({ type: 'GET_ALLIES_FROM_EVENTS_LOADING' })

        let db = firestoreInitialize();

        let first = db.collection('Aliados')
            .where('aliadoId', 'in', allies)

        first.get().then((querySnapshot) => {
            dispatch({ type: 'GET_ALLIES_FROM_EVENTS', payload: { data: querySnapshot.docs.map(doc => doc.data()) }});
        })
        .catch((error) => dispatch({ type: 'GET_ALLIES_FROM_EVENTS_ERROR', payload: { code: 'allies-events/error', message: error } }))
    }

    return (
        <EventsContext.Provider value={{
            eventsState: state.getEvents,
            getAlliesFromEventsState: state.getAlliesFromEvents,
            getEvents,
            getAlliesFromEvents
        }}>
            {props.children}
        </EventsContext.Provider>
    )
}

export default EventsState;
